module.exports = __webpack_public_path__ + "static/media/self-assessment-icon.bdc0e650.svg";